<div class="d-none d-sm-block" style="width: 100%; align-items: center;text-align: center; height: auto;">
    <br>
    <img src="assets/images/logo-almamedis.png" style="height: 83px; padding-left: 50px; float: left;">
    <br>
    <br>    
    <br>  
    <br>
    <br>
</div>


<div class="d-sm-none" style="width: 100%; align-items: center;text-align: center;">
    <br>
    <img src="assets/images/logo-almamedis.png" style="width:70%;">
    <br>  
    <br>
    <br>  
</div>

<div style="width: 100%; align-items: center;text-align: center;">
    <h1 class="letra-titulo">Validación de pacientes</h1>
</div>

<div class="d-none d-sm-block" style="width: 100%;">
  <br>
  <table style="width: 100%;">
      <td style="width: 30%;"></td>
      <td style="width: 40%;">
          <div class="card-padre" style="width: 100%;">
              <div class="card-datos">
                  <h1 class="letra-card-titulo">Ingrese el rut del Beneficiario</h1>
              </div>
              <br><br>
              <br>
              <div style="padding-left: 20px;width: 100%;padding-right: 20px;">
                <input
                  type="text"
                  name="id_documento"
                  class="form-control"
                  [formControl]="rutPacienteFind"
                  [ngClass]="{ 'is-invalid': rutPacienteFind.invalid && submitted }"
                  placeholder="Ingrese RUT del beneficiario"
                  (input)="onRutInput()"
                >
                <div *ngIf="rutPacienteFind.errors && submitted" class="invalid-feedback" style="text-align: left;">
                  <ng-container *ngIf="rutPacienteFind.errors['required']">
                    Este campo es obligatorio
                  </ng-container>
                  <ng-container *ngIf="rutPacienteFind.errors['rutInvalido']">
                    El RUT ingresado no es válido
                  </ng-container>
                </div>
              </div>
              <br>
              <div style="padding-left: 20px;padding-right: 20px;">
                <table style="width: 50%;">
                  <td style="width: 50%;text-align: center;">
                    <button class="btn btn-secondary letraBotonModal"
                            style="background: #0E0087;"
                            (click)='verificarPaciente()'
                            [disabled]="cargando">
                      Verificar
                    </button>
                  </td>
                </table>
              </div>

              <!-- Spinner -->
              <div *ngIf="cargando" style="text-align: center; margin-top: 10px;">
                <div class="loader">
                <div class="loader__figure"></div>
                <p class="loader__label">Medis</p>
              </div>
              </div>




              <div style="padding-left: 20px;padding-right: 20px;">
                <span class="text-danger" style="font-size: 16px; font-weight: 600;" *ngIf="pacienteValid == 2">
                  Paciente no tiene un plan activo
                </span>
                <span class="text-success" style="font-size: 16px; font-weight: 600;" *ngIf="pacienteValid == 1">
                  Paciente tiene un plan activo
                </span>
              </div>
          </div>
      </td>
      <td style="width: 30%;"></td>
  </table>
  
</div>
